import { ChooseItemsStepBody } from './choose-items-step-body';
import { ChooseItemsStepFooter } from './choose-items-step-footer';

import { messages } from './messages';

export const ChooseItemsStep = {
  id: 'choose-items',
  title: messages.chooseItemsStepText,
  body: <ChooseItemsStepBody />,
  footer: <ChooseItemsStepFooter />,
};
